import { useCallback } from 'react'

import { Maybe } from '@/app/graphql/generated'

const useScrollToBlock = () => {
  const scrollToSection = useCallback((id?: Maybe<string>) => {
    if (!id) return

    const element = document.getElementById(id)

    if (!element) return

    const elementTop = element.getBoundingClientRect().top + window.scrollY
    const targetPosition = elementTop - 137

    window.location.hash = `#${id}`
    setTimeout(() => {
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      })
    }, 100)
  }, [])

  const checkHashRoute = useCallback(
    (hash: string) => {
      if (!hash) return

      scrollToSection(hash.replace('#', ''))
    },
    [scrollToSection],
  )

  return {
    scrollToSection,
    checkHashRoute,
  }
}

export default useScrollToBlock
